// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContainersPage/ContainersPage.module.css */

.ContainersPage_root__UQ0\\+X {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: sans-serif;
}

.ContainersPage_header__Rs7KO {
  padding: 12px;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ContainersPage_datePicker__jgt8Z {
  width: 90%;
  max-width: 400px;    /* опционально, чтобы не был слишком широким на планшетах */
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  display: block;
  margin: 0 auto;
}

.ContainersPage_actions__1UNSo {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.ContainersPage_button__MT7ob {
  flex: 0 0 auto;   /* убираем растягивание */
  min-width: 100px;
  padding: 12px;
  border: none;
  border-radius: 6px;
  background: #007bff;
  color: #fff;
}
.ContainersPage_button__MT7ob:hover {
  background: #0056b3;   /* более тёмный оттенок */
  transform: translateY(-2px); /* лёгкий подъём */
}

.ContainersPage_content__fcOdK {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px;
  background: #fff;
}

.ContainersPage_loading__5Xwlf {
  text-align: center;
  margin-top: 20px;
}

.ContainersPage_list__USFNT {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ContainersPage_item__eb71U {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 12px;
  background: #fafafa;
}

.ContainersPage_itemRow__9U3bq {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.ContainersPage_label__eCYDJ {
  font-weight: bold;
}

.ContainersPage_value__-fe48 {
  text-align: right;
}

.ContainersPage_itemButtons__FWDwX {
  display: flex;
  gap: 6px;
  margin-top: 8px;
}

.ContainersPage_smallButton__PydfP {
  flex: 1 1;
  padding: 8px;
  font-size: 0.875rem;
  border: none;
  border-radius: 4px;
  background: #28a745;
  color: #fff;
}

.ContainersPage_fullContainer__GXuYu {
  background-color: #d4edda; /* светло-зелёный фон */
  border: 1px solid #28a745; /* зелёная рамка */
}
`, "",{"version":3,"sources":["webpack://./src/modules/Storekeeper/ContainersPage/ContainersPage.module.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,gBAAgB,KAAK,2DAA2D;EAChF,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc,IAAI,yBAAyB;EAC3C,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB,IAAI,yBAAyB;EAChD,2BAA2B,EAAE,kBAAkB;AACjD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,yBAAyB,EAAE,kBAAkB;AAC/C","sourcesContent":["/* ContainersPage/ContainersPage.module.css */\r\n\r\n.root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  font-family: sans-serif;\r\n}\r\n\r\n.header {\r\n  padding: 12px;\r\n  background: #f5f5f5;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.datePicker {\r\n  width: 90%;\r\n  max-width: 400px;    /* опционально, чтобы не был слишком широким на планшетах */\r\n  padding: 10px;\r\n  font-size: 1rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  display: block;\r\n  margin: 0 auto;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  overflow-x: auto;\r\n  padding-bottom: 4px;\r\n}\r\n\r\n.button {\r\n  flex: 0 0 auto;   /* убираем растягивание */\r\n  min-width: 100px;\r\n  padding: 12px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  background: #007bff;\r\n  color: #fff;\r\n}\r\n.button:hover {\r\n  background: #0056b3;   /* более тёмный оттенок */\r\n  transform: translateY(-2px); /* лёгкий подъём */\r\n}\r\n\r\n.content {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 12px;\r\n  background: #fff;\r\n}\r\n\r\n.loading {\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n\r\n.list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.item {\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  padding: 12px;\r\n  background: #fafafa;\r\n}\r\n\r\n.itemRow {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.label {\r\n  font-weight: bold;\r\n}\r\n\r\n.value {\r\n  text-align: right;\r\n}\r\n\r\n.itemButtons {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.smallButton {\r\n  flex: 1;\r\n  padding: 8px;\r\n  font-size: 0.875rem;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: #28a745;\r\n  color: #fff;\r\n}\r\n\r\n.fullContainer {\r\n  background-color: #d4edda; /* светло-зелёный фон */\r\n  border: 1px solid #28a745; /* зелёная рамка */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ContainersPage_root__UQ0+X`,
	"header": `ContainersPage_header__Rs7KO`,
	"datePicker": `ContainersPage_datePicker__jgt8Z`,
	"actions": `ContainersPage_actions__1UNSo`,
	"button": `ContainersPage_button__MT7ob`,
	"content": `ContainersPage_content__fcOdK`,
	"loading": `ContainersPage_loading__5Xwlf`,
	"list": `ContainersPage_list__USFNT`,
	"item": `ContainersPage_item__eb71U`,
	"itemRow": `ContainersPage_itemRow__9U3bq`,
	"label": `ContainersPage_label__eCYDJ`,
	"value": `ContainersPage_value__-fe48`,
	"itemButtons": `ContainersPage_itemButtons__FWDwX`,
	"smallButton": `ContainersPage_smallButton__PydfP`,
	"fullContainer": `ContainersPage_fullContainer__GXuYu`
};
export default ___CSS_LOADER_EXPORT___;
